import { Grid, Skeleton } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { useApiQuery } from "../../../../../../../core/api/useApiQuery"
import { RefetchIntervals } from "../../../../../../../core/api/refetchIntervals"
import { OrderType } from "../../../../../../payments/orderTypes"
import { fetchUserPos, FetchUserPosResponse, UserWeekMenu } from "../../../weekMenuApi"
import { PurchaseOrder } from "../../../weekMenuTypes"
import { DatePeriod } from "../../../../../../../shared/components/filters/selectDatePeriodFilter/SelectDatePeriodFilter"

import { CanteenPurchasesPanel } from "./CanteenPurchasesPanel"

const CANTEEN_ORDER_TYPES = new Set<string>([OrderType.LUNCH, OrderType.LUNCH_SUBSCRIPTION])

const useStyles = makeStyles()(() => ({
    column: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
    },
    skeletonCard: {
        height: "20rem",
        borderRadius: "1rem",
    },
}))

const selectCanteenPurchases = (data: FetchUserPosResponse): PurchaseOrder[] =>
    (data.orders ?? []).filter((order) => CANTEEN_ORDER_TYPES.has(order.orderType))

type UserPurchasesProps = Readonly<{
    period: DatePeriod
}>

export function UserPurchases({ period }: UserPurchasesProps) {
    const { classes } = useStyles()

    const { data: purchases, isLoading } = useApiQuery(fetchUserPos, {
        queryName: UserWeekMenu.USER_POS_PURCHASES,
        dependencies: {
            period,
            orderType: OrderType.LUNCH,
        },
        select: selectCanteenPurchases,
        refetchInterval: RefetchIntervals.short,
    })

    if (isLoading) {
        return (
            <Grid item xs={12} className={classes.column}>
                <Skeleton variant="rectangular" className={classes.skeletonCard} />
            </Grid>
        )
    }

    return (
        <Grid item xs={12} className={classes.column}>
            <CanteenPurchasesPanel purchases={purchases ?? []} period={period} />
        </Grid>
    )
}
